export const SELECTED_DEFAULT = 0;

export const SLASH_FORMAT_DATE = "YYYY/MM/DD";
export const DASH_FORMAT_DATE = "YYYY-MM-DD";
export const FORMAT_DATE_JA = "YYYY年M月D日";

export const REMARK_MAX_LENGTH = 100;
